import React from "react";

export const MdCellular = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M64 448h384V64L64 448z"/></svg>) as JSX.Element;
